import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import '../app.css'
import App from '../App.vue'
import financeRoutes from '../router/routes/finance'
import { initSentry } from '../lib/sentry'
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend, Filler } from 'chart.js'

// Register Chart.js components globally for the Finance app.
// Must be done at entry-point level so all scales are available
// regardless of which component mounts first.
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend, Filler)

// Branding
document.title = 'Finance | Codifyo'
const faviconLink = document.getElementById('favicon-link')
if (faviconLink) {
    faviconLink.setAttribute('href', '/favicon-finance.png')
}

const router = createRouter({
    history: createWebHistory(),
    routes: financeRoutes,
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth) && !localStorage.getItem('apiToken')) {
        next({ name: 'finance_login' })
    } else {
        next()
    }
})

const app = createApp(App)
app.use(router)
initSentry(app, router)
app.mount('#app')
